import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
    progressBarContainer: {
        width: '100%',
    },

    progressBar: {
        height: '4px',
        width: '100%',
        backgroundColor: '#fff',

        '& .MuiLinearProgress-bar': {
            backgroundColor: 'var(--color-success)',
        },

        [theme.breakpoints.down('576')]: {
            height: '4px',
        },
    },
}));

export default useStyles;
